import { render, staticRenderFns } from "./legal-documen-template-filter.vue?vue&type=template&id=11e04d8e"
import script from "./legal-documen-template-filter.vue?vue&type=script&lang=js"
export * from "./legal-documen-template-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports